export const parseTeamNames = (label: string): { home: string; away: string } => {
  if (!label) return { home: 'Home', away: 'Away' };
  // Label format: "Home Team - Away Team, Score1 - Score2"
  const commaIdx = label.lastIndexOf(',');
  const teamsPart = commaIdx > -1 ? label.substring(0, commaIdx) : label;
  const separatorIdx = teamsPart.indexOf(' - ');
  if (separatorIdx === -1) return { home: teamsPart.trim(), away: 'Away' };
  return {
    home: teamsPart.substring(0, separatorIdx).trim(),
    away: teamsPart.substring(separatorIdx + 3).trim(),
  };
};

/**
 * Whether to show the Hednesford "Our Team" formation pitch for a match.
 * Only true when our team id is one of the two teams in THIS match — so
 * opponent-vs-opponent league matches don't render an empty/broken pitch.
 */
export function shouldShowOurFormation(
  ourTeamId: number | null,
  homeTeamId: number,
  awayTeamId: number,
): boolean {
  return ourTeamId != null && (homeTeamId === ourTeamId || awayTeamId === ourTeamId);
}

export const formatDate = (dateStr: string) => {
  if (!dateStr) return 'N/A';
  try {
    const date = new Date(dateStr.replace(' ', 'T'));
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return dateStr;
  }
};
